import { jsx as i } from "react/jsx-runtime";
import { clx as o } from "../../utils/clx.js";
import { TimelineElement as f } from "./TimelineElement.js";
const d = ({
  items: e,
  className: n,
  "data-cy": r
}) => {
  if (!e || e.length === 0)
    return null;
  const a = e.length === 1;
  return /* @__PURE__ */ i(
    "div",
    {
      className: o(
        "flex flex-col items-start justify-start",
        n
      ),
      "data-name": "Timeline",
      "data-cy": r,
      children: e.map((m, t) => {
        let l = "Middle";
        return a ? l = "Single step" : t === 0 ? l = "Start" : t === e.length - 1 && (l = "End"), /* @__PURE__ */ i(
          f,
          {
            ...m,
            position: l,
            "data-cy": `timeline-element-${t}`
          },
          t
        );
      })
    }
  );
};
export {
  d as Timeline
};
